import React, { useState } from "react";
import { Typography, Modal, Button, Form ,message} from "antd";
import AppAlert from "../../../shared/appAlert";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { saveMerchant } from "../api";
import { fetchMerchantDetailes } from "./reducer";
import { isErrorDispaly } from "../../../shared/validationsAndExceptions/apiExceptions";
import { validateContentRule } from "../../../utils/custom.validator";
import { InfoCircleOutlined } from '@ant-design/icons';

const walletType=process.env.REACT_APP_WALLET_TYPE


const { Title } = Typography;

const Merchant = (props) => {
  const [form] = Form.useForm();
  const [error, setError] = useState(null);
  const [loader, setLoading] = useState(false);


  const handleCancel = () => {
    setLoading(false);
    props?.setIsshowModal(false);
    form.resetFields();
    setError(null);
  }
  const handleSave = async () => {
    const values = await form.validateFields();
    const trimmedFavouriteName = values.favouriteName.trim();
    let obj = {
      "id": "00000000-0000-0000-0000-000000000000",
      "customerId": props?.userConfig?.id,
      "merchantName": trimmedFavouriteName,
      "createdBy": props?.userConfig?.userName,
      "createdDate": new Date().toISOString(),
      "status": 0
    }
    try {
      setLoading(true);
      const response = await saveMerchant(obj);
      
      if (response.ok) {
        message.success({
          content: "Merchant saved successfully!",
          className: 'custom-msg',
          duration: 1
        });
        setTimeout(() => {
          setLoading(false);
          props.dispatch(fetchMerchantDetailes(props?.userConfig?.id));
          props?.setIsshowModal(false);
          form.resetFields();
        }, 3000);
      } else {
        setError(response.data.errors.DomainValidations[0]);
        setLoading(false);
      }
    } catch (errorMsg) {
      setError(isErrorDispaly(errorMsg.message));
      setLoading(false);
    }
  }


  return (<>
    <Modal
      wrapClassName='add-merchant invoice-modal'
      title={
        <Title className="card-title mb-0">Create New Merchant</Title>}
      visible={props?.showModal}
      closeIcon={true}
      onCancel={handleCancel}
      footer={[
        <>
          <Button style={{ width: 100 }}
            className="outlined-btn payee-popup pop-btn mr-8"
            onClick={handleCancel}>Cancel</Button>
          <Button className="btn-style payee-popup pop-btn"
            style={{ width: 100, height: 50 }} onClick={handleSave} loading={loader}
          >Save</Button>
        </>
      ]} >
      <Form form={form}>
        {error && <div className="alert-flex" style={{ width: "100%" }}><AppAlert description={error} type="error" showIcon onClose={() => setError(null)} /><span className="icon sm alert-close" onClick={() => setError(null)}></span></div>}
        <Form.Item
          className="payees-input mt-30 mb-30"
          name="favouriteName"
          label="Merchant Name"
          colon={false}
          rules={[
            { required: true, message: "Is required", whitespace: true },
            {
              validator: validateContentRule,
            },
          ]}
        >
          <input
            className="payees-input input-bordered text-left pl-18"
            placeholder="Enter Merchant Name"
            type="input"
            maxLength={50}
          />
        </Form.Item>
        {walletType !== 'non_custodial' && <div className="form-note" style={{ marginBottom: '20px', color: '#666', display: 'flex', alignItems: 'start' }}>
          <InfoCircleOutlined style={{ fontSize: '16px', marginRight: '8px', color: '#1890ff',}} className="merchant-infoicon" />
          <p style={{ margin: 0 }}>Note: Merchant save process might take up to 2 minutes.</p>
        </div>}
      </Form>
    </Modal>
  </>)
}
const connectStateToProps = ({ userConfig }) => {
  return { userConfig: userConfig.userProfileInfo};
};
const connectDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};
Merchant.propTypes = {
  userConfig: PropTypes.object,
  dispatch: PropTypes.func,
};
export default connect(
  connectStateToProps,
  connectDispatchToProps
)(Merchant);


